import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateProductTypeComponent = loadable(
  () => import("../../components/ProductType/CreateProductType")
);
const CreateProductType = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["product-type"],
    navigateURL: "/product-type",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.PRODUCT_TYPE}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Product Type
        </span>
      </div>
      <CreateProductTypeComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateProductType;
